/* scs-atc-feedback.js
   Drives idle → loading → success → idle on AJAX ATC buttons and
   idle → loading (spinner + "Processing...") on checkout buttons. Two
   document-level delegated listeners — no fetch wrapper, no form replacement.
   Checkout never disables the button (would cancel the native submit) and
   clears on navigation, or restores after an 8s safety timeout. */

(() => {
  const ATC_SEL = 'buy-button.buy-button button[type="submit"]';
  const CHECKOUT_SEL = 'button[name="checkout"].button--primary';

  // Set state on an AJAX ATC button. Snapshots innerHTML on first loading
  // entry and restores it at idle so theme button labels (price, icons) survive.
  // Clears any in-flight timer before every transition (prevents stuck states).
  function setAtcState(btn, state) {
    if (btn._scsTimer) {
      clearTimeout(btn._scsTimer);
      btn._scsTimer = null;
    }

    if (state === 'loading' && btn.dataset.atcState !== 'loading') {
      btn._scsOriginalHtml = btn.innerHTML;
    }

    btn.dataset.atcState = state;
    btn.disabled = (state === 'loading' || state === 'success');

    if (state === 'loading') {
      btn.innerHTML =
        '<span class="scs-atc-spinner" aria-hidden="true"></span><span>Adding...</span>';
    } else if (state === 'success') {
      btn.innerHTML = '<span aria-hidden="true">✓</span><span>Added to cart</span>';
    } else {
      // idle — restore original markup
      if (btn._scsOriginalHtml != null) {
        btn.innerHTML = btn._scsOriginalHtml;
        delete btn._scsOriginalHtml;
      }
      btn.disabled = false;
    }
  }

  // Capture phase — fires before buy-button's stopPropagation (theme.js ~10939)
  // and before Navidium's element-level capture handler (custom.js ~770).
  // Never calls preventDefault or stopPropagation.
  function onDocClick(e) {
    const atcBtn = e.target.closest(ATC_SEL);
    if (atcBtn) {
      setAtcState(atcBtn, 'loading');
      return;
    }
    const coBtn = e.target.closest(CHECKOUT_SEL);
    if (coBtn && coBtn.dataset.atcState !== 'loading') {
      // Checkout: spinner + label, but never disable — these are native form
      // submits (the protection handler in custom.js drives its own navigation),
      // so disabling here during capture would cancel the submit. No success
      // state. Snapshot innerHTML and restore it after an 8s safety timeout in
      // case navigation never fires (e.g. the protection error path); a normal
      // checkout navigates away first and never restores.
      coBtn._scsOriginalHtml = coBtn.innerHTML;
      coBtn.dataset.atcState = 'loading';
      coBtn.innerHTML =
        '<span class="scs-atc-spinner" aria-hidden="true"></span><span>Processing...</span>';
      if (coBtn._scsTimer) clearTimeout(coBtn._scsTimer);
      coBtn._scsTimer = setTimeout(() => {
        coBtn.dataset.atcState = 'idle';
        if (coBtn._scsOriginalHtml != null) {
          coBtn.innerHTML = coBtn._scsOriginalHtml;
          delete coBtn._scsOriginalHtml;
        }
      }, 8000);
    }
  }
  document.addEventListener('click', onDocClick, true);

  // product:added bubbles to documentElement (theme.js ~10962).
  // Guards on detail.button presence + atcState === 'loading' so
  // Cube Finder's button-less dispatch ({ quantity: 1 }) is ignored.
  document.documentElement.addEventListener('product:added', (e) => {
    try {
      const btn = e.detail && e.detail.button;
      if (!btn || btn.dataset.atcState !== 'loading') return;

      if (e.detail.productAdded) {
        setAtcState(btn, 'success');
        btn._scsTimer = setTimeout(() => setAtcState(btn, 'idle'), 2200);
      } else {
        // Failed add — never leave button stuck
        setAtcState(btn, 'idle');
      }
    } catch (err) {
      console.error('[scs-atc] product:added handler error', err);
    }
  });
})();
